"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_SIGNAL_INTERVAL = exports.MESSAGE_TIMEOUT = exports.MESSAGES = exports.MAX_DISCONNECTION_TIME = exports.DOES_NOT_SUPPORT_WEBRTC = exports.DISCONNECT_ACTION = void 0;
var DISCONNECT_ACTION = {
  DISCONNECTING: 0,
  DISCONNECTED: 1
};
exports.DISCONNECT_ACTION = DISCONNECT_ACTION;
var DOES_NOT_SUPPORT_WEBRTC = 0;
exports.DOES_NOT_SUPPORT_WEBRTC = DOES_NOT_SUPPORT_WEBRTC;
var MESSAGES = {
  PUBLISHER_DISCONNECTED: function PUBLISHER_DISCONNECTED() {
    return 'You have been disconnected. Please check your internet connection, trying to reconnect.';
  },
  PUBLISHER_CONNECTED: function PUBLISHER_CONNECTED() {
    return 'You are connected!';
  },
  SUBSCRIBER_DISCONNECTED: function SUBSCRIBER_DISCONNECTED(name) {
    return "".concat(name, " has been disconnected, please wait while they attempt to reconnect.");
  },
  SUBSCRIBER_CONNECTED: function SUBSCRIBER_CONNECTED(name) {
    return "".concat(name, " is connected!");
  },
  SUBSCRIBER_DESTROYED: function SUBSCRIBER_DESTROYED(name) {
    return "".concat(name, " was unable to reconnect. Please contact them to retry.");
  },
  SUBSCRIBER_VIDEO_QUALITY_LOW: function SUBSCRIBER_VIDEO_QUALITY_LOW() {
    return 'Video temporarily disabled due to low video quality.';
  },
  SUBSCRIBER_LEFT: function SUBSCRIBER_LEFT(name) {
    return "".concat(name, " left the call");
  }
};
exports.MESSAGES = MESSAGES;
var MESSAGE_TIMEOUT = 3000;
exports.MESSAGE_TIMEOUT = MESSAGE_TIMEOUT;
var VIDEO_SIGNAL_INTERVAL = 2000;
exports.VIDEO_SIGNAL_INTERVAL = VIDEO_SIGNAL_INTERVAL;
var MAX_DISCONNECTION_TIME = 45000;
exports.MAX_DISCONNECTION_TIME = MAX_DISCONNECTION_TIME;